
// Function to update menu detail box with data from header menu item
function updateMenuDetailBoxFromHeaderMenuItem(summaryElement) {
    // Find the closest ".menu-content" element within the closest ".mega-menu"
    const menuContent = summaryElement.closest('.mega-menu').querySelector('.menu-content');

    // Check if menuContent is not null
    if (menuContent) {
        // Get the value of the "data-title" attribute from the header menu item summary
        const title = summaryElement.getAttribute('data-title');

        // Find the ".menu-detail-box" element within the ".menu-content"
        const menuDetailBox = menuContent.querySelector('.menu-detail-box');

        // Check if menuDetailBox is not null
        if (menuDetailBox) {
            // Find the title element within the ".menu-detail-box" and set its text
            const titleElement = menuDetailBox.querySelector('.menu-detail-title');
            if (titleElement) {
                titleElement.textContent = title;
            }

           

            // Get the value of the "data-detail" attribute from the header menu item summary
            const detail = summaryElement.getAttribute('data-detail');

            // Find the details element within the ".menu-detail-box" and set its text
            const detailElement = menuDetailBox.querySelector('.menu-detail-details');
            if (detailElement) {
                detailElement.textContent = detail;
            }

            // Get the value of the "data-img" attribute from the header menu item summary
            const imgSrc = summaryElement.getAttribute('data-img');

            // Find the image element within the ".menu-detail-box" and set its src attribute
            const imgElement = menuContent.querySelector('.menu-detail-img');
          
            if (imgElement) {
              console.log(imgSrc);
                imgElement.setAttribute('src', imgSrc);
            }
        }
    }
}

// Add event listener to all ".sub-menu-link" elements
document.querySelectorAll('.sub-menu-link').forEach(subMenuLink => {
    // Mouseover event listener
    subMenuLink.addEventListener('mouseover', event => {
        // Call the function to update the menu detail box with data from sub-menu link
        updateMenuDetailBoxFromHeaderMenuItem(subMenuLink);
    });

    // Mouseleave event listener
    subMenuLink.addEventListener('mouseleave', event => {
        // Find the ".header__menu-item" summary element within the closest ".mega-menu"
        const summaryElement = event.target.closest('.mega-menu').querySelector('summary.header__menu-item');

        // Call the function to update the menu detail box with data from header menu item
        updateMenuDetailBoxFromHeaderMenuItem(summaryElement);
    });
});


document.addEventListener('DOMContentLoaded', () => {
    const megaMenu = document.querySelector('.mega-menu');
    const headerWrapper = document.querySelector('.header-wrapper');

    // Function to toggle the class
    function toggleMegaMenuClass() {
        if (megaMenu.hasAttribute('open')) {
            headerWrapper.classList.add('open-mega-menu');
        } else {
            headerWrapper.classList.remove('open-mega-menu');
        }
    }

    // Listen for changes to the "open" attribute
    const observer = new MutationObserver(toggleMegaMenuClass);

    observer.observe(megaMenu, {
        attributes: true,
        attributeFilter: ['open'], // Only observe changes to the "open" attribute
    });

    // Initial check
    toggleMegaMenuClass();
});


 document.querySelectorAll('.product-detail-accordion .product-detail-holder h5').forEach(function(heading) {
  heading.addEventListener('click', function() {
    // Find the closest .product-detail-holder element
    var productDetailHolder = this.closest('.product-detail-holder');
    
    // Toggle the 'open' class on the closest .product-detail-holder
    productDetailHolder.classList.toggle('open');
  });
});



//const checkpincodebtn_element = document.getElementById('check-pincode-btn');

    // Check if the element exists
 

      
document.getElementById("check-pincode-btn").addEventListener("click", function() {
        // Get the pincode value
        var pincode = document.getElementById("pincode").value;

if (pincode.length === 6){
      
    document.getElementById("pincode-box-msg").innerHTML = "<span style=''>Processing...</span>";
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    var raw = JSON.stringify({
      "email": "shopify@flyinghawk.co",
      "password": "Api@FlyingHawk_1234##"
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch("https://apiv2.shiprocket.in/v1/external/auth/login", requestOptions)
      .then(response => response.json()) // Parse response as JSON
      .then(result => {
        // Extract token from the result and log it
        var token = result.token;
        console.log(token);
    
     
        var requestOptions2 = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      redirect: 'follow'
    };

    console.log(requestOptions2);
    fetch("https://apiv2.shiprocket.in/v1/external/courier/serviceability/?pickup_postcode=452001&delivery_postcode=" + pincode + "&weight=1&cod=0", requestOptions2)
      .then(response => response.json())
      .then(result => {
        console.log(result);
        if (result.status === 200) {
                              // Display message if pincode is serviceable
                            document.getElementById("pincode-box-msg").innerHTML = "<span style='color: #15994f'>Pincode is serviceable</span>";
                        } else {
                            // Display message if pincode is not serviceable
                            document.getElementById("pincode-box-msg").innerHTML = "<span style='color: #C5292A'>Pincode is not serviceable</span>";
                        }
      })
      .catch(error =>{
        document.getElementById("pincode-box-msg").innerHTML = "<span style='color: #C5292A'>"+error+"</span>";
      });
    
  })
  .catch(error => console.log('error', error));
}else{
  document.getElementById("pincode-box-msg").innerHTML = "<span style='color: #C5292A'>Please enter valid pincode</span>";
}
});





// Wait for the document to be fully loaded
document.addEventListener("DOMContentLoaded", function() {
    // Delay execution for 100 milliseconds after the DOMContentLoaded event
setTimeout(function() {
    // Find the legend element with class name-option and data-name attribute equal to "Select Size"
    var legendElement = document.querySelector('legend.name-option[data-name="Shoe size"]');

    // Create the button element
    var sizeChartButton = document.createElement('a');
    sizeChartButton.href = "#";
    sizeChartButton.className = "size-chart-btn";
    sizeChartButton.id= "size-chart-btn";
    sizeChartButton.textContent = "Size Guide";

    // Append the button after the legend element
    if (legendElement) {
        legendElement.appendChild(sizeChartButton);

      // Event listener for clicking on element with class "product-info"
        var sizeGuideInfoElements = document.querySelectorAll('.size-chart-btn');
        sizeGuideInfoElements.forEach(function(element) {
            element.addEventListener('click', function() {
                activateSizeGuideDrawer();
            });
        });
        
        // Event listener for clicking on element with class "product-info-close"
        var sizeGuideInfoClose = document.querySelector('.size-guide-close');
        if (sizeGuideInfoClose) {
            sizeGuideInfoClose.addEventListener('click', function() {
                deactivateSizeGuideDrawer();
            });
        }
    }

}, 5000); // Delay in milliseconds

});

// Function to add class "active" to the product info drawer box
    function activateSizeGuideDrawer() {
        var sizeGuideInfoDrawer = document.getElementById('size-guide-box');
        if (sizeGuideInfoDrawer) {
            sizeGuideInfoDrawer.classList.add('active');
        }
    }

    function deactivateSizeGuideDrawer() {
        var sizeGuideInfoDrawer = document.getElementById('size-guide-box');
        if (sizeGuideInfoDrawer) {
            sizeGuideInfoDrawer.classList.remove('active');
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        var sizeGuideInfoElements = document.querySelectorAll('.size-chart-btn');
        sizeGuideInfoElements.forEach(function(element) {
            element.addEventListener('click', function() {
                activateSizeGuideDrawer();
            });
        });
        
        var sizeGuideInfoClose = document.querySelector('.size-guide-close');
      var sizeGuideInfoClose1 = document.querySelector('.size-guide-close-1');
      
        if (sizeGuideInfoClose || sizeGuideInfoClose1) {
            sizeGuideInfoClose.addEventListener('click', function() {
                deactivateSizeGuideDrawer();
            });
            sizeGuideInfoClose1.addEventListener('click', function() {
                deactivateSizeGuideDrawer();
            });
        }
    });